import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import config from 'app/config'

export function defaultTransformFn<T>(response: { data: T }) {
  return response.data
}

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: config.api.BASEURL }),
  endpoints: () => ({})
})
